export default __webpack_public_path__ + "static/media/sinopec.f410adc1.png";